"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketVersioningInput_1 = require("./PutBucketVersioningInput");
var PutBucketVersioningOutput_1 = require("./PutBucketVersioningOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketVersioning = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketVersioning",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?versioning"
    },
    input: {
        shape: PutBucketVersioningInput_1.PutBucketVersioningInput
    },
    output: {
        shape: PutBucketVersioningOutput_1.PutBucketVersioningOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketVersioning.js.map